import browsePage from './browsePage/reducer';
import activeInvestments from './activeInvestments/reducer';
import pastInvestments from './pastInvestments/reducer';

export default {
  browsePage,
  activeInvestments,
  pastInvestments,
};
